enum MODAL {
  SHARE = 'share',
}

export { MODAL }
